import ModalProvider from "../contexts/ModalProvider";

function MainLayout({ children }) {
  return (
    <>
      <ModalProvider>{children}</ModalProvider>
    </>
  );
}

export default MainLayout;
